module.exports = __webpack_public_path__ + "img/9.ebd18604.jpg";